import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as reportsActions from '../../actions/Reports';
import Campaign from './Tabs/Campaign/';
import Settings from './Tabs/Settings/';
import LocaleComponent from '../../LocaleComponent';

class Campaigns extends LocaleComponent {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);

    this.state = {
      tab: 'campaign',
    };
  }

  componentDidMount() {
    const { campaigns, location } = this.props;
    const params = this.parseParams(location.search);

    if (!campaigns.campaigns) {
      const id = this.getMcId();
      this.props.getCampaigns(id);
    }

    if (params.tab && params.tab !== this.state.tab) {
      this.setState({ tab: params.tab })
    }

    this.props.selectMenu('campaigns');
  }

  toggle(tab) {
    if (this.state.tab !== tab) {
      const params = {
        tab,
        searchText: '',
      };
      const path = this.stringfy(params);
      this.props.history.replace(path);
      this.setState({ tab });
    }
  }

  render() {
    const { campaigns } = this.props;
    const { tab } = this.state;

    const classNameForTab = (t) => {
      return (t === tab) ? "btn btn-primary btn-sm" : "btn btn-default btn-sm";
    };

    const switchBox = (
      <form action="" method="post" className="form-horizontal">
        <div className="form-group">
          <button type="button" className={classNameForTab('campaign')}
                  onClick={() => this.toggle('campaign')}>
            <i className="fa fa-key" />&nbsp; {this.localeMessage('Campaign')}</button>
          <button type="button" className={classNameForTab('settings')}
                  onClick={() => this.toggle('settings')}>
            <i className="fa fa-gavel" />&nbsp; {this.localeMessage('Settings')}</button>
        </div>
      </form>
    );

    return (
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-md-10">
            {switchBox}
          </div>
        </div>
        {tab === 'campaign' && <Campaign {...this.props} campaigns={campaigns.campaigns} />}
        {tab === 'settings' && <Settings {...this.props} settings={campaigns.campaign_settings} />}
      </div>
    );
  }
}

class CampaignsContainer extends Component {
  render() {
    return <Campaigns
      {...this.props}
      {...bindActionCreators({
        ...reportsActions,
      }, this.props.dispatch)} />;
  }
}

CampaignsContainer = connect(state => ({
  customers: state.reports.get('customers'),
  campaigns: state.reports.get('campaigns'),
  groupedCampaigns: state.reports.get('groupedCampaigns'),
  selectedLocale: state.reports.get('selectedLocale'),
  translations: state.reports.get('translations'),
}))(CampaignsContainer);

export default CampaignsContainer;



// WEBPACK FOOTER //
// ./src/views/Campaigns/Campaigns.js